<template>
    <p :class="['field', { invalid: isInvalid }]">
        <label v-if="required" :for="id">
            <slot></slot>
            *<span v-if="helpText"> ({{ helpText }})</span> <slot name="afterText"></slot>
        </label>
        <label v-else :for="id">
            <slot></slot>
            <span v-if="helpText"> ({{ helpText }})</span> <slot name="afterText"></slot>
        </label>
        <input :type="inputType" :autocomplete="autocomplete"
               size="30"
               :id="id"
               :name="id"
               :value="value"
               :disabled="disabled"
               :maxlength="maxLength"
               @input="emitChange($event.target.value)"
               @focus="emitFocus"
               @blur="emitBlur(true)"
        />
        <span class="invalid_help" v-if="isInvalid && invalidText">{{ invalidText }}</span>
        <input v-if="withSubmit" type="submit" class="btn" :value="'Uložit' | translate"
               @click.prevent.stop="$emit('submit')">
    </p>
</template>

<script>
	export default {
		name: "TextInput",
		data() {
			return {
				touched: false,
				forcedInvalid: false,
				invalidText: null,
			}
		},
		model: {
			prop: 'value',
			event: 'change'
		},
		props: {
			id: String,
			value: [String, Number],
			helpText: {
				type: String,
				default: ''
			},
			required: {
				type: Boolean,
				default: false
			},
			inputType: {
				type: String,
				default: 'text'
			},
			disabled: {
				type: Boolean,
				default: false
			},
			autocomplete: {
				type: String,
				default: 'new-password'
			},
			withSubmit: {
				type: Boolean,
				default: false
			},
      maxLength: {
			  type: Number|String,
        default: null
      }
		},
		computed: {
			isInvalid() {
				return (this.touched && this.required && (!this.value || this.value.length === 0)) || this.isForcedInvalid
			},
			isForcedInvalid() {
				return this.forcedInvalid
			}
		},
		methods: {
			emitChange(value) {
				this.$emit('change', value)
				this.setTouched(true)
			},
			emitFocus() {
				this.$emit('focus', true)
			},
			setTouched(value) {
				this.touched = value
			},
			emitBlur(value) {
				this.setTouched(value)
				this.$emit('blur', value)
			},
			setForcedInvalid(value = false, invalidText = null) {
				this.forcedInvalid = value
				this.invalidText = value === false ? null : invalidText
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/common/TextInput.vue